import {PageFragment, PageFragmentProps, PageFragmentState, PageFragmentStyleFlags} from "../../shared/PageFragment";
import React, {ReactElement} from "react";
import {StyledContainer} from "../../shared/StyledComponents";

export type BaseAppletProps = PageFragmentProps & {}

export type BaseAppletState = PageFragmentState & {}

export abstract class BaseApplet<P extends BaseAppletProps = BaseAppletProps, S extends BaseAppletState = BaseAppletState> extends PageFragment<P, S> {

  protected styleFlags(): number | PageFragmentStyleFlags {
    return PageFragment.STYLE_BACK_BUTTON_FLAG | PageFragment.STYLE_TOOLBAR_TYPE_FLAG;
  }

  onBackButtonClicked() {
    this.props.path.navigate("..");
  }

  renderContent(): React.ReactElement {
    return <StyledContainer gutter={true} style={{flexGrow: 1}}>
      {this.renderApplet()}
    </StyledContainer>;
  }

  protected abstract renderApplet(): ReactElement;
}